module.exports = __webpack_public_path__ + "03_short_black.751fd350.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_short_black.png
// module id = 44D8
// module chunks = 0